<template>
  <v-app style="background: rgba(0, 0, 0, 0)">
    <v-navigation-drawer
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      app
      v-if="current_client && token"
      class="elevation-6"
    >
      <v-list class="pt-0" dense>
        <v-img
          :src="require('@/assets/cabinet.svg')"
          height="120"
          class="bottom-gradient hidden-xs-only elevation-3 myscale"
        ></v-img>
        <v-divider></v-divider>
        <v-layout pa-2 column fill-height class="lightbox center">
          <v-spacer></v-spacer>
          <v-layout column align-center>
            <div class="subheading">
              <b>Издательство «Музыка»</b>
            </div>
            <div class="body-1">Личный кабинет пользователя</div>
            <small>версия {{ version }}</small>
          </v-layout>
        </v-layout>
        <v-divider class="elevation-3"></v-divider>
        <v-list-tile
          v-for="item in menuitems"
          :key="item.title"
          @click="$store.commit('change_active_page', item.page)"
          :class="{ mymenu: $store.state.active_page == item.page }"
          ripple
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      v-if="current_client && token"
      dark
      color="primary"
      fixed
      app
      :clipped-left="clipped"
      dense
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>

      <v-toolbar-title class="white--text">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" flat block>
              <v-icon>arrow_drop_down</v-icon>
              &nbsp; {{ client.name }} &nbsp; &nbsp;
            </v-btn>
          </template>
          <v-list>
            <v-list-tile
              v-for="(item, index) in this.current_client"
              :key="index"
              @click="change_client(index)"
            >
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content v-if="current_client && token">
      <transition name="fade">
        <v-container
          v-if="$store.state.active_page == 1 && expand_orders()"
          fluid
        >
          <v-card>
            <v-card-title class="grey lighten-5">
              <h3 class="headline mb-0">
                <v-icon medium color="green">fa-key</v-icon>
                &nbsp;&nbsp;&nbsp; Мои продукты
              </h3>
              <v-spacer></v-spacer>
              <v-btn color="info" @click="register_barcode_dialog = true">
                Регистрация скретч-карты&nbsp;&nbsp;
                <v-icon light>fa-compact-disc</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="ma-0 pt-0">
              <v-card-title class="ma-0 pa-2">
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="subsearch"
                  append-icon="search"
                  label="поиск"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="subHeaders"
                :items="product_keys"
                :search="subsearch"
                item-key="product_serial"
                hide-actions
                class="elevation-1"
                no-data-text="Зарегистрируйте серийный номер продукта, нажав на кнопку «Регистрация скретч-карты»."
                style="padding: 0px !important"
              >
                <template slot="items" scope="props">
                  <tr
                    @click="props.expanded = !props.expanded"
                    :class="[
                      {
                        'grey lighten-3': props.expanded
                      }
                    ]"
                  >
                    <td class="text-xs-right" nowrap>
                      <v-icon v-if="props.expanded" small>expand_less</v-icon>
                      <v-icon v-else small>expand_more</v-icon>
                      {{ props.item.product_text_id }}
                    </td>
                    <td class="text-xs-right">
                      {{ props.item.product_name }}
                      <span
                        v-if="
                          props.item.active_till_date &&
                            new Date(props.item.active_till_date).setHours(
                              0,
                              0,
                              0,
                              0
                            ) < currentDate
                        "
                        style="color: red;"
                      >
                        &nbsp;(лицензия истекла)
                      </span>
                    </td>
                    <td nowrap class="text-xs-right">
                      <v-icon
                        color="green"
                        v-if="
                          props.item.active_from_date &&
                            new Date(props.item.active_till_date).setHours(
                              0,
                              0,
                              0,
                              0
                            ) >= currentDate
                        "
                        medium
                        >check</v-icon
                      >
                      <v-icon
                        color="grey"
                        v-if="
                          props.item.active_from_date &&
                            new Date(props.item.active_till_date).setHours(
                              0,
                              0,
                              0,
                              0
                            ) < currentDate
                        "
                        medium
                        >check</v-icon
                      >
                      {{ props.item.product_serial }}
                    </td>
                    <td nowrap class="text-xs-right">
                      {{ props.item.order_name }}
                    </td>
                  </tr>
                </template>
                <template v-slot:expand="props">
                  <v-card class="text-xs-center">
                    <v-layout justify-end wrap>
                      <v-chip
                        color="#575757"
                        outline
                        disabled
                        small
                        v-if="props.item.active_from_date"
                      >
                        <b>Дата активации:&nbsp;</b>

                        {{ props.item.active_from_date | format_date }}
                      </v-chip>

                      <v-chip
                        color="#575757"
                        outline
                        disabled
                        class="px-2"
                        small
                        v-if="props.item.active_till_date"
                      >
                        <b>Дата окончания:&nbsp;</b>

                        {{ props.item.active_till_date | format_date }}
                      </v-chip>
                      <v-chip
                        color="#575757"
                        outline
                        disabled
                        class="px-2"
                        small
                        v-if="props.item.computer_id"
                      >
                        <b>Идентификационный номер компьютера:&nbsp;</b>
                        {{ props.item.computer_id }}
                      </v-chip>
                      <v-chip
                        color="#575757"
                        outline
                        class="px-2"
                        small
                        v-if="props.item.user_id"
                        v-clipboard:copy="props.item.user_id"
                        v-clipboard:success="onCopyClipboard"
                        v-clipboard:error="onErrorClipboard"
                      >
                        <v-icon small>fa-copy</v-icon>
                        <b>&nbsp;&nbsp;Имя пользователя:&nbsp;</b>
                        {{ props.item.user_id }}
                      </v-chip>
                      <v-chip
                        color="#575757"
                        outline
                        class="px-2"
                        small
                        v-if="props.item.activation_id"
                        v-clipboard:copy="props.item.activation_id"
                        v-clipboard:success="onCopyClipboard"
                        v-clipboard:error="onErrorClipboard"
                      >
                        <v-icon small>fa-copy</v-icon>
                        <b>&nbsp;&nbsp;Ключ активации:&nbsp;</b>
                        {{ props.item.activation_id }}
                      </v-chip>

                      <div
                        class="px-2"
                        v-if="
                          !props.item.activation_id && props.item.is_bundle != 1
                        "
                      >
                        <v-btn
                          color="success"
                          @click="
                            act_product_name = props.item.product_name;
                            act_product_serial = props.item.product_serial;
                            activate_dialog = true;
                          "
                        >
                          Активировать&nbsp;&nbsp;
                          <v-icon light>lock</v-icon>
                        </v-btn>
                      </div>
                      <div class="px-2" v-if="props.item.is_bundle != 1">
                        <v-btn
                          color="info"
                          :href="
                            'https://lk.musica.ru/download/' +
                              props.item.product_download_url
                          "
                          target="_blank"
                        >
                          Загрузить&nbsp;&nbsp;
                          <v-icon light>cloud_download</v-icon>
                        </v-btn>
                      </div>
                      <div class="px-2" v-if="props.item.is_bundle === 1">
                        <v-btn
                          color="info"
                          href="https://edu.e-musica.ru/"
                          target="_blank"
                        >
                          Открыть ЭБС E-Musica&nbsp;&nbsp;
                          <v-icon light>menu_book</v-icon>
                        </v-btn>
                      </div>
                      <div
                        class="px-2"
                        v-if="
                          props.item.is_bundle === 1 &&
                            props.item.active_from_date &&
                            props.item.active_till_date
                        "
                      >
                        <v-btn
                          color="success"
                          @click="
                            act_product_name = props.item.product_name;
                            act_product_serial = props.item.product_serial;
                            load_product_users(props.item.product_serial);
                          "
                        >
                          Редактировать пользователей&nbsp;&nbsp;
                          <v-icon light>edit</v-icon>
                        </v-btn>

                        <v-btn color="success" @click="load_ebs_log()"
                          >Статистика пользователей&nbsp;&nbsp;</v-btn
                        >
                      </div>
                      <div
                        class="px-2"
                        v-if="
                          props.item.is_bundle === 1 &&
                            (!props.item.active_from_date ||
                              !props.item.active_till_date)
                        "
                      >
                        <v-btn
                          color="success"
                          @click.prevent="
                            act_product_name = props.item.product_name;
                            act_product_serial = props.item.product_serial;
                            activate_ebs_serial($event);
                          "
                        >
                          Активировать&nbsp;&nbsp;
                          <v-icon light>edit</v-icon>
                        </v-btn>
                      </div>
                    </v-layout>
                  </v-card>
                </template>
              </v-data-table>
              <p></p>
              <p></p>
              <center>
                <a
                  href="https://vk.com/video-42933108_456239404?list=ln-AteQ1HemzmJwe3WGFa"
                  target="_blank"
                  rel="noopener"
                  style="text-decoration: none"
                >
                  <v-card ripple hover>
                    <v-card-text>
                      <h4 style="text-align: center; text-transform: uppercase">
                        Видеоинструкция по установке интерактивных электронных
                        изданий
                      </h4>
                    </v-card-text>
                  </v-card>
                </a>
                <p></p>
                <a
                  href="https://emusica.storage.yandexcloud.net/files/instructions/instruction-interactive.pdf"
                  target="_blank"
                  rel="noopener"
                  style="text-decoration: none"
                >
                  <v-card ripple hover>
                    <v-card-text>
                      <h4 style="text-align: center; text-transform: uppercase">
                        Инструкция по установке интерактивных электронных
                        изданий&nbsp;&nbsp;
                        <v-icon>fa-file-pdf</v-icon>
                      </h4>
                    </v-card-text>
                  </v-card>
                </a>
                <p></p>
                <a
                  href="https://emusica.storage.yandexcloud.net/files/instructions/instruction-EBS.pdf"
                  target="_blank"
                  rel="noopener"
                  style="text-decoration: none"
                >
                  <v-card ripple hover>
                    <v-card-text>
                      <h4 style="text-align: center; text-transform: uppercase">
                        Инструкция по подключению к ЭБС E-MUSICA&nbsp;&nbsp;
                        <v-icon>fa-file-pdf</v-icon>
                      </h4>
                    </v-card-text>
                  </v-card>
                </a>
              </center>
            </v-card-text>
          </v-card>
          <v-dialog persistent v-model="activate_dialog" max-width="1000">
            <v-form>
              <v-card>
                <v-card-text>
                  <h3>Активация продукта:</h3>
                  &nbsp;{{ act_product_name }}
                  <br />
                  <h3>Серийный номер:</h3>
                  &nbsp;{{ act_product_serial }}
                  <br />
                  <v-text-field
                    prepend-icon="computer"
                    name="act_hw_id"
                    label="Идентификационный номер компьютера"
                    hint="Номер будет показан при запуске приложения"
                    type="text"
                    v-model="act_hw_id"
                    required
                  ></v-text-field>
                  <v-text-field
                    prepend-icon="person"
                    name="act_user_id"
                    label="Имя пользователя"
                    hint="Введите имя пользователя (или организации) приложения."
                    type="text"
                    v-model="act_user_id"
                    required
                  ></v-text-field>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat="flat" @click="activate_dialog = false"
                    >Отменить</v-btn
                  >
                  <v-btn
                    type="submit"
                    color="primary"
                    @click.prevent="activate_key($event)"
                  >
                    Активировать&nbsp;
                    <v-icon>arrow_forward</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <v-dialog
            persistent
            v-model="edit_users_dialog"
            max-width="90%"
            content-class="flex_dialog"
          >
            <v-form class="flex_form">
              <v-card class="flex_card">
                <v-card-text class="flex_card">
                  <h3>Продукт:</h3>
                  &nbsp;{{ act_product_name }}
                  <br />
                  <h3>Серийный номер:</h3>
                  &nbsp;{{ act_product_serial }}
                  <br />
                  <ag-grid-vue
                    style="width: 100%; flex-grow: 1;"
                    class="ag-theme-quartz"
                    :columnDefs="columnDefsUsers"
                    :rowData="rowDataUsers"
                    :autoSizeStrategy="autoSizeStrategy"
                    undoRedoCellEditing="true"
                    undoRedoCellEditingLimit="20"
                    rowGroupPanelShow="always"
                    enableRangeSelection="true"
                    @grid-ready="onGridReadyUsers"
                    @cellValueChanged="save_users"
                    :localeText="russian_locale"
                  ></ag-grid-vue>
                  <!-- <v-card flat v-for="(user, index) in users_list" :key="index">
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <v-text-field class="px-2" prepend-icon="person" :label="'ФИО пользователя №' + (index + 1)" type="text" v-model="user.user_fullname" required></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field class="px-2" :label="'Email пользователя №' + (index + 1)" hint="требуется для получения доступа" type="text" v-model="user.user_email" required></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card> -->
                </v-card-text>

                <v-card-actions>
                  <v-btn color="info" rounded @click="onXlsBtnExportUsers()">
                    Загрузить в формате Excel&nbsp;&nbsp;
                    <v-icon light>cloud_download</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    flat="flat"
                    :disabled="disable_cancel_button"
                    @click="edit_users_dialog = false"
                    >Отменить</v-btn
                  >
                  <v-btn
                    type="submit"
                    :disabled="disable_save_button"
                    color="primary"
                    @click.prevent="save_product_users(act_product_serial)"
                  >
                    Сохранить&nbsp;
                    <v-icon v-if="!disable_cancel_button">save</v-icon>
                    <v-progress-circular
                      v-else
                      indeterminate
                      :size="20"
                      :width="2"
                    ></v-progress-circular>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <v-dialog
            v-model="ebs_stats_dialog"
            max-width="90%"
            content-class="flex_dialog"
          >
            <v-form class="flex_form">
              <v-card class="flex_card">
                <v-card-text class="flex_card">
                  <h3>Статистика использования ЭБС</h3>
                  <br />
                  <ag-grid-vue
                    style="width: 100%; flex-grow: 1;"
                    class="ag-theme-quartz"
                    :autoSizeStrategy="autoSizeStrategy"
                    :columnDefs="columnDefs"
                    :rowData="rowData"
                    rowGroupPanelShow="always"
                    enableRangeSelection="true"
                    @grid-ready="onGridReady"
                    :localeText="russian_locale"
                  ></ag-grid-vue>
                </v-card-text>

                <v-card-actions>
                  <v-btn color="info" rounded @click="onXlsBtnExport()">
                    Загрузить в формате Excel&nbsp;&nbsp;
                    <v-icon light>cloud_download</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn flat="flat" @click="ebs_stats_dialog = false"
                    >Отменить</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <v-dialog
            persistent
            v-model="register_barcode_dialog"
            max-width="700"
          >
            <v-form>
              <v-card>
                <v-card-text>
                  <h3>Регистрация продукта</h3>
                  &nbsp;Введите серийный номер продукта, который находится под
                  защитным слоем скретч-карты
                  <v-text-field
                    prepend-icon="fa-key"
                    name="act_product_barcode"
                    label="Серийный номер продукта"
                    hint="Номер находится под стираемым слоем скретч-карты"
                    type="text"
                    v-model="act_product_barcode"
                    required
                  ></v-text-field>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn flat="flat" @click="register_barcode_dialog = false"
                    >Отменить</v-btn
                  >
                  <v-btn
                    type="submit"
                    color="primary"
                    @click.prevent="register_barcode($event)"
                  >
                    Зарегистрировать&nbsp;
                    <v-icon>arrow_forward</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
        </v-container>
      </transition>
      <!-- <transition name="fade">
        <v-container v-if="$store.state.active_page == 2" fluid>
          <v-card class="grey lighten-5">
            <v-card-title>
              <h3 class="headline mb-0">
                <v-icon medium color="green">fa-truck</v-icon>
                Новые заказы
              </h3>
              <v-spacer></v-spacer>
              <v-text-field v-model="search_new" append-icon="search" label="поиск" single-line hide-details></v-text-field>
            </v-card-title>
            <v-divider></v-divider>
            <v-data-table :headers="headers_new" :items="orders_new" :search="search_new" item-key="order_id" class="elevation-1" id="neworders_table" ref="neworders_table">
              <template v-slot:items="props">
                <tr @click="props.expanded = !props.expanded" class="neworders_table_row">
                  <td nowrap class="text-xs-right">
                    <v-icon v-if="props.expanded" small>expand_less</v-icon>
                    <v-icon v-else small>expand_more</v-icon>
                    ЭОРП-00000{{ props.item.order_id }}-19
                  </td>
                  <td class="text-xs-right">
                    {{ props.item.order_date | format_date }}
                  </td>
                  <td class="text-xs-right">
                    {{ props.item.comments }}
                  </td>
                  <td class="text-xs-right">
                    {{ props.item.order_status }}
                  </td>
                  <td class="text-xs-right">
                    {{ props.item.manager_name }}
                  </td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <v-card-text>
                  <v-card-title>
                    <h3>
                      <v-icon small color="blue">fa-key</v-icon>
                      &nbsp;Список продуктов
                    </h3>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="subsearch_new" append-icon="search" label="поиск" single-line hide-details></v-text-field>
                  </v-card-title>
                  <v-data-table :headers="subHeaders_new" :items="props.item.items" :search="subsearch_new" item-key="item_id" hide-actions class="elevation-1">
                    <template slot="items" scope="props">
                      <td class="text-xs-right" width="130px" nowrap>
                        <v-img :src="props.item.product_picture_url" class="ma-1" />
                      </td>
                      <td class="text-xs-right" nowrap>
                        {{ props.item.product_text_id }}
                      </td>
                      <td class="text-xs-right pr-0">
                        {{ props.item.product_name }}
                      </td>
                      <td nowrap class="text-xs-right">
                        <v-text-field min="1" max="999" v-model="props.item.quantity" hide-details flat type="number" class="mb-1 d-inline-block mynumber"></v-text-field>
                      </td>
                      <td class="text-xs-right" nowrap>
                        {{ (props.item.product_price * props.item.quantity) | numberWithCommas }}
                        ₽
                      </td>
                      <td class="text-xs-right ma-0 pa-0">
                        <v-btn fab small dark color="red" class="elevation-3" @click="delete_item(props.item)">
                          <v-icon dark>clear</v-icon>
                        </v-btn>
                      </td>
                    </template>
                    <template v-slot:footer>
                      <tr>
                        <td :colspan="subHeaders_new.length - 2" class="text-xs-right pa-0 ma-0">Итого:</td>
                        <td nowrap class="font-weight-bold">
                          {{ props.item.items | calc_total | numberWithCommas }}
                          ₽
                        </td>

                        <td></td>
                      </tr>

                      <tr>
                        <td :colspan="subHeaders_new.length" class="text-xs-right pa-0 ma-0">
                          Добавить продукты
                          <v-btn
                            fab
                            small
                            dark
                            color="blue"
                            class="elevation-3"
                            @click.stop="
                              add_newitem2(props.item);
                              dialog = true;
                            "
                          >
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-text>
                  <v-btn color="primary">
                    Получить документы&nbsp;&nbsp;
                    <v-icon>cloud_download</v-icon>
                  </v-btn>
                  <v-btn color="error" @click="delete_order(props.item, $event)">
                    Удалить заказ&nbsp;&nbsp;
                    <v-icon>delete_forever</v-icon>
                  </v-btn>
                  <v-btn color="info" @click="save_order(props.item, $event)">
                    Сохранить заказ&nbsp;&nbsp;
                    <v-icon>save</v-icon>
                  </v-btn>
                  <v-btn color="success" @click="save_order(props.item, $event)">
                    Оформить заказ&nbsp;&nbsp;
                    <v-icon>send</v-icon>
                  </v-btn>
                </v-card-text>
              </template>
              <template v-slot:footer>
                <td :colspan="headers_new.length" class="text-xs-right pa-0 ma-0">
                  Создать новый заказ
                  <v-btn fab small dark color="green" class="elevation-3" @click="create_order()">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card>
          <v-dialog v-model="dialog" max-width="1000">
            <v-card>
              <v-card-text class="ma-0 pa-0">
                <v-data-table :headers="productHeaders" :items="products" item-key="product_text_id" hide-actions class="elevation-0">
                  <template slot="items" scope="props">
                    <tr
                      @click="
                        add_newitem(props.item);
                        dialog = false;
                      "
                    >
                      <td nowrap class="text-xs-right" width="150px">
                        <v-img :src="props.item.product_picture_url" class="ma-1" />
                      </td>
                      <td class="text-xs-right" nowrap>
                        {{ props.item.product_text_id }}
                      </td>
                      <td class="text-xs-right">
                        {{ props.item.product_name }}
                        <br />
                        {{ props.item.product_price | numberWithCommas }}
                        ₽
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat="flat" @click="dialog = false">Отменить</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
      </transition> -->

      <!-- Форма для редактирования данных организации -->
      <transition name="fade">
        <v-container v-if="$store.state.active_page == 3" fluid>
          <v-card>
            <v-card-text>
              <v-form v-model="formValid">
                <v-jsonschema-form
                  v-if="showCompanyForm"
                  :schema="schema"
                  :model="client"
                  :options="formOptions"
                  @error="showError"
                  @change="showChange"
                  @input="showInput"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="info"
                @click="formOptions.disableAll = false"
                v-if="formOptions.disableAll == true"
              >
                Редактировать&nbsp;&nbsp;
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn
                color="error"
                @click="cancelEditCompany"
                v-if="formOptions.disableAll == false"
              >
                Отменить&nbsp;&nbsp;
                <v-icon>undo</v-icon>
              </v-btn>
              <v-btn
                color="info"
                @click="save_client($event)"
                v-if="formOptions.disableAll == false"
              >
                Сохранить&nbsp;&nbsp;
                <v-icon>save</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
      </transition>
      <!-- Форма для редактирования данных пользователя  -->
      <transition name="fade">
        <v-container v-if="$store.state.active_page == 4" fluid>
          <v-card>
            <v-card-text>
              <h3>Пользователь:</h3>
              &nbsp;{{ fullname }}
              <h3>Email:</h3>
              &nbsp;{{ username }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="info" @click="reset_password($event)">
                Сбросить пароль&nbsp;&nbsp;
                <v-icon>vpn_key</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
      </transition>
      <!-- Форма со справочной информацией  -->
      <transition name="fade">
        <v-container v-if="$store.state.active_page == 5" fluid>
          <v-layout align-center justify-center>
            <v-flex xs12 sm10 md8>
              <v-card>
                <v-card-text style="text-align: justify">
                  <h2>Добро пожаловать в личный кабинет пользователя!</h2>
                  <p>
                    Личный кабинет пользователя позволяет администраторам
                    организаций загружать и активировать интерактивные
                    электронные издания, а также управлять подпиской на ЭБС
                    E-MUSICA.
                  </p>
                  <p></p>
                  <p>
                    Для загрузки и активации ваших продуктов или доступа к ЭБС
                    выберите слева пункт меню «Мои продукты». Если вы не видите
                    пункты меню, то вам необходимо нажать на кнопку меню (три
                    полоски) в верхнем левом углу для его раскрытия.
                  </p>
                  <p></p>
                  <p>
                    Ниже размещены инструкции по установке интерактивных
                    электронных зданий и по подключению к ЭБС E-MUSICA.
                  </p>
                  <p>
                    <b
                      >Если у вас возникли вопросы по работе с программными
                      продуктами или доступом к ЭБС, рекомендуем обращаться в
                      нашу службу технической поддержки через
                      <a
                        href="https://t.me/publishing_muzyka"
                        target="_blank"
                        rel="noopener"
                      >
                        Telegram</a
                      >
                      (@publishing_muzyka). Также вы можете написать на емейл
                      <a href="mailto:support@musica.ru">support@musica.ru</a>
                      или позвонить по телефону +7 (499) 503-77-37 доб. 146 с 10
                      до 18 по московскому времени. Обращения через Telegram
                      обрабатываются в первую очередь.</b
                    >
                  </p>
                  <center>
                    <a
                      href="https://vk.com/video-42933108_456239404?list=ln-AteQ1HemzmJwe3WGFa"
                      target="_blank"
                      rel="noopener"
                      style="text-decoration: none"
                    >
                      <v-card ripple hover>
                        <v-card-text>
                          <h4
                            style="text-align: center; text-transform: uppercase"
                          >
                            Видеоинструкция по установке интерактивных
                            электронных изданий
                          </h4>
                        </v-card-text>
                      </v-card>
                    </a>
                    <p></p>
                    <a
                      href="https://emusica.storage.yandexcloud.net/files/instructions/instruction-interactive.pdf"
                      target="_blank"
                      rel="noopener"
                      style="text-decoration: none"
                    >
                      <v-card ripple hover>
                        <v-card-text>
                          <h4
                            style="text-align: center; text-transform: uppercase"
                          >
                            Инструкция по установке интерактивных электронных
                            изданий&nbsp;&nbsp;
                            <v-icon>fa-file-pdf</v-icon>
                          </h4>
                        </v-card-text>
                      </v-card>
                    </a>
                    <p></p>
                    <a
                      href="https://emusica.storage.yandexcloud.net/files/instructions/instruction-EBS.pdf"
                      target="_blank"
                      rel="noopener"
                      style="text-decoration: none"
                    >
                      <v-card ripple hover>
                        <v-card-text>
                          <h4
                            style="text-align: center; text-transform: uppercase"
                          >
                            Инструкция по подключению к ЭБС E-MUSICA&nbsp;&nbsp;
                            <v-icon>fa-file-pdf</v-icon>
                          </h4>
                        </v-card-text>
                      </v-card>
                    </a>
                  </center>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </transition>
      <!-- Форма для завершения сеанса  -->
      <transition name="fade">
        <v-container v-if="$store.state.active_page == 6" fluid>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <v-card>
                <v-card-text
                  >Нажмите на кнопку "Выйти" для того, чтобы завершить текущий
                  сеанс пользователя</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="info" @click="logout_user">
                    Выйти&nbsp;&nbsp;
                    <v-icon>fa-sign-out-alt</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </transition>

      <v-snackbar v-model="showsnack" top>
        {{ snack_message }}
        <v-btn flat color="accent" @click.native="showsnack = false"
          >Закрыть</v-btn
        >
      </v-snackbar>
    </v-content>
    <!-- Форма для входа в систему или регистрации  -->
    <v-content v-if="!token">
      <transition name="fade">
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <v-tabs
                grow
                class="elevation-6"
                style="overflow: hidden"
                icons-and-text
              >
                <v-tab ripple>
                  Вход
                  <v-icon>exit_to_app</v-icon>
                </v-tab>
                <v-tab ripple>
                  Регистрация
                  <v-icon>person_add</v-icon>
                </v-tab>
                <v-tab-item>
                  <v-form v-model="loginform_valid" ref="loginform">
                    <v-card>
                      <v-card-text>
                        <v-text-field
                          prepend-icon="person"
                          name="username"
                          label="Имя пользователя (email)"
                          hint="Введите адрес электронной почты, указанный при регистрации"
                          type="text"
                          v-model="username"
                          required
                        ></v-text-field>
                        <v-text-field
                          prepend-icon="lock"
                          name="password"
                          label="Пароль"
                          hint="Введите пароль, указанный при регистрации"
                          type="password"
                          v-model="password"
                          :rules="passwordRules"
                          counter
                          required
                        ></v-text-field>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn flat @click.prevent="reset_password($event)"
                          >Забыли пароль?</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                          type="submit"
                          color="primary"
                          @click.prevent="login_user($event)"
                          block
                        >
                          Вход&nbsp;
                          <v-icon>arrow_forward</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-form>
                </v-tab-item>

                <v-tab-item>
                  <v-form v-model="regform_valid" ref="regform">
                    <v-card>
                      <v-card-text>
                        <v-text-field
                          prepend-icon="person"
                          name="fullname"
                          label="Полное имя (ФИО)"
                          hint="Как к вам обращаться"
                          type="text"
                          v-model="fullname"
                          :rules="fullnameRules"
                          required
                        ></v-text-field>
                        <v-text-field
                          prepend-icon="email"
                          name="username"
                          label="Email (будет выслано письмо с подтверждением регистрации)"
                          type="text"
                          hint="Введите адрес электронной почты, который будет использоваться для входа в личный кабинет"
                          v-model="username"
                          :rules="emailRules"
                          required
                        ></v-text-field>

                        <v-text-field
                          prepend-icon="lock"
                          name="password"
                          label="Пароль"
                          type="password"
                          hint="Придумайте пароль для входа в личный кабинет"
                          v-model="password"
                          :rules="passwordRules"
                          counter
                          required
                        ></v-text-field>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn flat @click.prevent="show_help_register()"
                          >Нужна помощь?</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                          type="submit"
                          color="primary"
                          @click.prevent="register_user($event)"
                        >
                          Регистрация&nbsp;
                          <v-icon>account_circle</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-form>
                </v-tab-item>
              </v-tabs>
              <p></p>
              <p></p>
              <a
                href="https://vk.com/video-42933108_456239404?list=ln-AteQ1HemzmJwe3WGFa"
                target="_blank"
                rel="noopener"
                style="text-decoration: none"
              >
                <v-card ripple hover>
                  <v-card-text>
                    <h4 style="text-align: center; text-transform: uppercase">
                      Видеоинструкция по установке интерактивных электронных
                      изданий
                    </h4>
                  </v-card-text>
                </v-card>
              </a>
              <p></p>
              <a
                href="https://emusica.storage.yandexcloud.net/files/instructions/instruction-interactive.pdf"
                target="_blank"
                rel="noopener"
                style="text-decoration: none"
              >
                <v-card ripple hover>
                  <v-card-text>
                    <h4 style="text-align: center; text-transform: uppercase">
                      Инструкция по установке интерактивных электронных
                      изданий&nbsp;&nbsp;
                      <v-icon>fa-file-pdf</v-icon>
                    </h4>
                  </v-card-text>
                </v-card>
              </a>
              <p></p>
              <a
                href="https://emusica.storage.yandexcloud.net/files/instructions/instruction-EBS.pdf"
                target="_blank"
                rel="noopener"
                style="text-decoration: none"
              >
                <v-card ripple hover>
                  <v-card-text>
                    <h4 style="text-align: center; text-transform: uppercase">
                      Инструкция по подключению к ЭБС E-MUSICA&nbsp;&nbsp;
                      <v-icon>fa-file-pdf</v-icon>
                    </h4>
                  </v-card-text>
                </v-card>
              </a>
            </v-flex>
          </v-layout>
        </v-container>
      </transition>
      <v-snackbar v-model="showsnack" top>
        {{ snack_message }}
        <v-btn flat color="accent" @click.native="showsnack = false"
          >Закрыть</v-btn
        >
      </v-snackbar>
    </v-content>

    <!-- Форма первоначальной регистрации в системе  -->
    <v-content v-if="new_client && token">
      <transition name="fade">
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-stepper v-model="e1" style="overflow: hidden !important">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1"
                  >Название компании</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2"
                  >Проверка данных</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step step="3">Завершение</v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card flat>
                    <h4>
                      Для завершения регистрации введите Название или ИНН
                      компании
                    </h4>
                    <v-card-text>
                      <v-text-field
                        label="Название компании"
                        hint="поиск по названию компании и ИНН"
                        type="text"
                        v-model="new_company_name"
                        id="ContactFormOrganization"
                      ></v-text-field>
                      <v-text-field
                        v-if="new_legal_address"
                        label="Юридический адрес"
                        hint="Юридический адрес организации, которую вы представляете"
                        type="text"
                        v-model="new_legal_address"
                        disabled
                      ></v-text-field>
                      <v-text-field
                        v-if="new_fio"
                        label="Руководитель"
                        hint="ФИО руководителя организации, которую вы представляете"
                        type="text"
                        v-model="new_fio"
                        disabled
                      ></v-text-field>
                      <v-text-field
                        v-if="new_position"
                        label="Должность руководителя"
                        hint="Должность руководителя организации, которую вы представляете"
                        type="text"
                        v-model="new_position"
                        disabled
                      ></v-text-field>
                      <v-text-field
                        v-if="new_inn"
                        label="ИНН компании"
                        hint="ИНН организации, которую вы представляете"
                        type="text"
                        v-model="new_inn"
                        id="ContactFormINN"
                        disabled
                      ></v-text-field>
                      <v-text-field
                        v-if="new_kpp"
                        label="КПП компании"
                        hint="КПП организации, которую вы представляете"
                        type="text"
                        v-model="new_kpp"
                        id="ContactFormKPP"
                        disabled
                      ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="logout_user"
                        >Отмена&nbsp;&nbsp;</v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="verify_inn($event)"
                        >Далее</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-card flat>
                    <v-card-text>
                      <h4>{{ new_inn_status }}</h4>
                      <v-text-field
                        v-if="!new_company_exists && !verify_product_key"
                        label="Название компании"
                        hint="Уточните название организации, которую вы представляете"
                        type="text"
                        v-model="new_company_name"
                      ></v-text-field>
                      <v-text-field
                        v-if="!new_company_exists && !verify_product_key"
                        label="Юридический адрес"
                        hint="Юридический адрес организации, которую вы представляете"
                        type="text"
                        v-model="new_legal_address"
                      ></v-text-field>
                      <v-text-field
                        v-if="!new_company_exists && !verify_product_key"
                        label="Руководитель"
                        hint="ФИО руководителя организации, которую вы представляете"
                        type="text"
                        v-model="new_fio"
                      ></v-text-field>
                      <v-text-field
                        v-if="!new_company_exists && !verify_product_key"
                        label="Должность руководителя"
                        hint="Должность руководителя организации, которую вы представляете"
                        type="text"
                        v-model="new_position"
                      ></v-text-field>
                      <v-text-field
                        v-if="!new_company_exists && !verify_product_key"
                        label="ИНН компании"
                        hint="ИНН организации, которую вы представляете"
                        type="text"
                        v-model="new_inn"
                        disabled
                      ></v-text-field>
                      <v-text-field
                        v-if="!new_company_exists && !verify_product_key"
                        label="КПП компании"
                        hint="КПП организации, которую вы представляете"
                        type="text"
                        v-model="new_kpp"
                        disabled
                      ></v-text-field>

                      <h5 v-if="new_company_exists && !verify_product_key">
                        Нажмите далее для подключения учётной записи к данной
                        компании
                      </h5>
                      <v-text-field
                        v-if="verify_product_key"
                        prepend-icon="fa-key"
                        name="new_product_key"
                        label="Серийный номер продукта"
                        hint="Введите любой из серийных номеров для проверки"
                        type="text"
                        v-model="new_product_key"
                        required
                      ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        @click="
                          new_company_exists = false;
                          verify_product_key = false;
                          e1 = 1;
                        "
                        flat
                      >
                        Назад
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="join_to_company($event)"
                        >Далее</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-card flat>
                    <v-card-text
                      >Поздравляем! Регистрация прошла успешно!</v-card-text
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        @click="
                          new_client = null;
                          refresh_client_data();
                        "
                      >
                        Завершить
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-layout>
        </v-container>
      </transition>
      <v-snackbar v-model="showsnack" top>
        {{ snack_message }}
        <v-btn flat color="accent" @click.native="showsnack = false"
          >Закрыть</v-btn
        >
      </v-snackbar>
    </v-content>
    <v-btn
      fab
      dark
      fixed
      bottom
      right
      color="#0088cc"
      href="https://t.me/publishing_muzyka"
      target="_blank"
      class="elevation-10"
      style="bottom: 20px; left: 20px; z-index: 99;"
    >
      <v-icon>fab fa-telegram-plane</v-icon>
    </v-btn>
  </v-app>
</template>
<script>
import axios from "axios";
import { AgGridVue } from "ag-grid-vue";

import VJsonschemaForm from "@koumoul/vuetify-jsonschema-form/lib/index.vue";

// import VJsonschemaForm from "@koumoul/vuetify-jsonschema-form";
import "@koumoul/vuetify-jsonschema-form/dist/main.css";

import { constants } from "crypto";
import { truncate } from "fs";

export default {
  components: { VJsonschemaForm, AgGridVue },

  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Организация",
        field: "client_name",
        filter: true,
        enableRowGroup: true
      },
      {
        headerName: "ИНН",
        field: "client_inn",
        filter: true,
        enableRowGroup: true
      },
      {
        headerName: "Дата",
        field: "access_date",
        cellDataType: "dateString",
        filter: "agDateColumnFilter",
        enableRowGroup: true
      },
      { headerName: "Время", field: "access_time", filter: true },
      {
        headerName: "Email пользователя",
        field: "user_email",
        filter: true,
        enableRowGroup: true
      },
      {
        headerName: "Имя пользователя",
        field: "user_fullname",
        filter: true,
        enableRowGroup: true
      },
      {
        headerName: "Группа",
        field: "comments",
        filter: true,
        enableRowGroup: true
      },
      {
        headerName: "Артикул",
        field: "book_id",
        filter: true,
        enableRowGroup: true
      },
      {
        headerName: "Наименование",
        field: "book_name",
        width: 100,
        suppressSizeToFit: true,
        filter: true,
        enableRowGroup: true
      },
      {
        headerName: "IP адрес",
        field: "ip_address",
        filter: true,
        enableRowGroup: true
      }
    ];
    this.columnDefsUsers = [
      {
        headerName: "Email пользователя",
        field: "user_email",
        filter: true,
        enableRowGroup: true,
        editable: true
      },
      {
        headerName: "Имя пользователя",
        field: "user_fullname",
        filter: true,
        enableRowGroup: true,
        editable: true
      },
      {
        headerName: "Группа",
        field: "comments",
        filter: true,
        enableRowGroup: true,
        editable: true
      },
      {
        headerName: "Дата обновления",
        field: "last_update_time",
        enableRowGroup: true
      }
    ];
    //    this.rowData = [{ make: "Toyota", model: "Celica", price: 35000 }, { make: "Ford", model: "Mondeo", price: 32000 }, { make: "Porsche", model: "Boxster", price: 72000 }];
    // fetch("http://192.168.0.100:5000/v2/client/log/123123")
    //   .then((result) => result.json())
    //   .then((rowData) => (this.rowData = rowData));
  },
  methods: {
    save_users(params) {
      this.disable_save_button = false;
      // console.log("MUST SAVE!" + params);
    },
    onGridReady(params) {
      this.gridApi = params.api;
    },
    onGridReadyUsers(params) {
      this.gridApiUsers = params.api;
    },
    onXlsBtnExport() {
      this.gridApi.exportDataAsExcel();
    },
    onXlsBtnExportUsers() {
      this.gridApiUsers.exportDataAsExcel();
    },
    async cancelEditCompany() {
      this.formOptions.disableAll = true;

      await this.refresh_client_data();
      this.snack_message = "Изменения отменены";
      this.showsnack = true;

      this.showCompanyForm = false;
      this.$nextTick(() => {
        this.showCompanyForm = true;
      });
    },
    //методы для формы VJsonschemaForm
    showError(err) {
      window.alert(err);
    },
    showChange(e) {
      console.log('"change" event', e);
    },
    showInput(e) {
      console.log('"input" event', e);
    },
    activate_ebs_serial(event) {
      let mybutton = event.currentTarget;
      this.$confirm(
        "Вы уверены, что хотите хотите активировать серийный номер?<br>Подписка будет активна с текущей даты в течение 365 календарных дней.",
        {
          title: "Внимание"
        }
      ).then(res => {
        if (res) {
          console.log("activating product...");
          mybutton.classList.add("v-btn--disabled");
          this.http
            .post("/activate/ebs/", {
              client_inn: this.client.inn,
              product_key: this.act_product_serial
            })
            .then(response => {
              console.log(response);
              this.refresh_client_data();
              this.activate_dialog = false;
              this.snack_message = response.data;
              this.showsnack = true;
              mybutton.classList.remove("v-btn--disabled");
            })
            .catch(error => {
              console.log(error);
              mybutton.classList.remove("v-btn--disabled");
            });
        }
      });
      return;
    },
    load_ebs_log() {
      this.http
        .get("/client/log/" + this.client.inn)
        .then(response => {
          // console.log(response);
          this.rowData = response.data;
          this.ebs_stats_dialog = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    load_product_users(product) {
      this.http
        .get(
          "/client/" +
            this.client.inn +
            "/users/" +
            product.split("-").join(""),
          {}
        )
        .then(response => {
          console.log(response);
          this.users_list = response.data;
          this.rowDataUsers = response.data;
          this.disable_save_button = true;
          this.edit_users_dialog = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    save_product_users(product) {
      console.dir(this.users_list);
      this.disable_save_button = true;
      this.disable_cancel_button = true;
      this.http
        .post(
          "/client/" +
            this.client.inn +
            "/users/" +
            product.split("-").join(""),
          this.users_list
        )
        .then(response => {
          console.log(response);
          this.disable_cancel_button = false;
          this.edit_users_dialog = false;
        })
        .catch(error => {
          console.log(error);
          this.disable_cancel_button = false;
          this.edit_users_dialog = false;
        });
    },
    logout_user() {
      console.log("Deleting tokens...");
      this.$store.commit("set_token", null);
      this.password = null;
      this.current_client = null;
      this.current_client_index = 0;
      this.new_client = null;
      this.e1 = 0;
      return;
    },
    login_user(event) {
      if (this.$refs.loginform.validate()) {
        console.log("Trying to login with username " + this.username);

        let mybutton = event.currentTarget;

        mybutton.classList.add("v-btn--disabled");
        this.http
          .post("/auth/", {
            username: this.username,
            password: this.password
          })
          .then(response => {
            console.log(response);

            console.log(response.data.user_token);
            if (response.data.user_token) {
              if (response.data.user_token === "verify email") {
                this.snack_message =
                  "Подтвердите регистрацию по ссылке в письме";
                this.showsnack = true;
                this.resend_email(mybutton);
              } else {
                this.snack_message = "Вход успешный";
                this.showsnack = true;
                this.$store.commit("set_token", response.data.user_token);
                this.$store.commit("change_active_page", 5);
                this.password = null;
                this.$nextTick(() => {
                  this.refresh_client_data();
                });
              }
            } else {
              this.snack_message = "Неверное имя пользователя или пароль";
              this.showsnack = true;
            }

            mybutton.classList.remove("v-btn--disabled");
          })
          .catch(error => {
            console.log(error);
            mybutton.classList.remove("v-btn--disabled");
          });
        return;

        this.$store.commit("set_token", null);
        return;
      }
    },
    register_user(event) {
      if (this.$refs.regform.validate()) {
        console.log("Trying to register new user " + this.username);

        let mybutton = event.currentTarget;

        mybutton.classList.add("v-btn--disabled");
        this.http
          .post("/register/", {
            username: this.username,
            password: this.password,
            fullname: this.fullname
          })
          .then(response => {
            console.log(response);
            if (response.data === "Username already exists") {
              this.snack_message =
                "Пользователь с таким email уже существует в системе";
              this.showsnack = true;
            }
            if (response.data === "Username registered") {
              this.snack_message = "Подтвердите регистрацию по ссылке в письме";
              this.showsnack = true;
            }
            mybutton.classList.remove("v-btn--disabled");
          })
          .catch(error => {
            console.log(error);
            mybutton.classList.remove("v-btn--disabled");
          });
        return;
      }
    },
    resend_email(mybutton) {
      // let mybutton = event.currentTarget;
      this.$confirm(
        "<center>Выслать повторно письмо с регистрацией?</center>"
      ).then(res => {
        if (res) {
          console.log("request new email with registration link...");
          mybutton.classList.add("v-btn--disabled");
          this.http
            .post("/register/resend/", { username: this.username })
            .then(response => {
              console.log(response);
              this.snack_message = "Выслано повторное письмо";
              this.showsnack = true;
              mybutton.classList.remove("v-btn--disabled");
            })
            .catch(error => {
              console.log(error);
              mybutton.classList.remove("v-btn--disabled");
            });
        }
      });
      return;
    },
    reset_password(event) {
      let mybutton = event.currentTarget;
      this.$confirm("<center>Сбросить пароль?</center>").then(res => {
        if (res) {
          console.log("request password reset link...");
          mybutton.classList.add("v-btn--disabled");
          this.http
            .post("/register/reset/", { username: this.username })
            .then(response => {
              console.log(response);
              this.snack_message = response.data;
              this.showsnack = true;
              mybutton.classList.remove("v-btn--disabled");
            })
            .catch(error => {
              console.log(error);
              mybutton.classList.remove("v-btn--disabled");
            });
        }
      });
      return;
    },
    show_help_register() {
      this.$confirm(
        "<center>Если у вас возникли вопросы по процессу установки программных продуктов, то вы	можете обратиться в нашу службу технической поддержки по телефону: +7 (499) 503-77-37 доб.146 с 10 до 18 по московскому времени.</center>"
      ).then(res => {});
      return;
    },
    confirm_email() {
      if (this.$route.query.confirm) {
        this.http
          .get("/confirm/" + this.$route.query.confirm, {})
          .then(response => {
            console.log(response);
            this.snack_message = response.data;
            this.showsnack = true;
            this.$router.replace({ query: null });
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    confirm_password() {
      if (this.$route.query.reset) {
        this.http
          .post("/register/reset/" + this.$route.query.reset, {
            password: this.password
          })
          .then(response => {
            console.log(response);
            this.snack_message = response.data;
            this.showsnack = true;
            this.$router.replace({ query: null });
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    // Проверяем статус компании по ИНН для первоначальной регистрации
    verify_inn(event) {
      let mybutton = event.currentTarget;

      mybutton.classList.add("v-btn--disabled");
      this.http
        .get("/client/" + this.new_inn + "/verify/", {})
        .then(response => {
          console.log(response);
          if (response.data.client) {
            this.new_inn_status = "Компания с таким ИНН найдена";
            if (response.data.orders) {
              this.new_inn_status =
                "Компания с таким ИНН найдена, требуется проверка по серийному номеру";
              this.verify_product_key = true;
            } else {
              this.new_inn_status =
                "Компания с таким ИНН найдена, проверка не требуется";
              this.new_company_exists = true;
            }
          } else {
            this.new_inn_status = "Проверьте правильность данных о компании";
          }
          this.e1 = 2;
          mybutton.classList.remove("v-btn--disabled");
        })
        .catch(error => {
          console.log(error);
          mybutton.classList.remove("v-btn--disabled");
        });
      return;
    },
    join_to_company(event) {
      let mybutton = event.currentTarget;
      mybutton.classList.add("v-btn--disabled");
      if (!this.new_company_exists && !this.verify_product_key) {
        this.http
          .post("/clients/" + this.token, {
            client_inn: this.new_inn,
            client_name: this.new_company_name,
            client_legal_address: this.new_legal_address,
            client_kpp: this.new_kpp,
            client_fio: this.new_fio,
            client_position: this.new_position
          })
          .then(response => {
            console.log(response);
            if (response.data === "ok") {
              this.e1 = 3;
            }
            mybutton.classList.remove("v-btn--disabled");
          })
          .catch(error => {
            console.log(error);
            mybutton.classList.remove("v-btn--disabled");
          });
      } else {
        this.http
          .post("/clients/" + this.new_inn + "/" + this.token, {
            product_key: this.new_product_key
          })
          .then(response => {
            console.log(response);
            if (response.data === "ok") {
              this.e1 = 3;
            } else {
              this.snack_message = response.data;
              this.showsnack = true;
            }
            mybutton.classList.remove("v-btn--disabled");
          })
          .catch(error => {
            console.log(error);
            mybutton.classList.remove("v-btn--disabled");
          });
      }
      return;
    },

    change_client(index) {
      console.log(
        "new client name: (",
        index + ") " + this.current_client[index].name
      );
      this.current_client_index = index;
      this.refresh_client_data();
    },
    // Методы для работы с заказами
    delete_item(myitem) {
      for (let i = 0; i < this.orders_new.length; i++) {
        if (this.orders_new[i].items.indexOf(myitem) != -1) {
          console.log("нашли переменную в массиве под номером: " + i);
          const myindex = this.orders_new[i].items.indexOf(myitem);
          this.orders_new[i].items.splice(myindex, 1);
        }
      }
      return;
    },
    add_newitem2(myitem) {
      console.log("ищем переменную в массиве " + myitem);
      const myindex = this.orders_new.indexOf(myitem);
      this.orders_new_index = myindex;
      console.log(myindex);
    },
    add_newitem(myitem) {
      for (
        let i = 0;
        i < this.orders_new[this.orders_new_index].items.length;
        i++
      ) {
        if (
          this.orders_new[this.orders_new_index].items[i].product_text_id ===
          myitem.product_text_id
        ) {
          // Товар есть в списке, увеличиваем количество на 1
          this.orders_new[this.orders_new_index].items[i].quantity++;
          return;
        }
      }
      // Товара нет в списке, добавляем новую позицию
      this.orders_new[this.orders_new_index].items.push({
        product_text_id: myitem.product_text_id,
        product_name: myitem.product_name,
        product_picture_url: myitem.product_picture_url,
        product_price: myitem.product_price,
        quantity: 1
      });

      return;
    },
    expand_orders() {
      if (
        this.orders.length > 0 &&
        !this.activate_dialog &&
        !this.orders_expanded
      ) {
        this.$nextTick(() => {
          let orders_table = this.$refs["orders_table"];
          let last_page = Math.ceil(
            orders_table.itemsLength /
              orders_table.computedPagination.rowsPerPage
          );
          this.$refs["orders_table"].updatePagination({
            page: last_page
          });
          this.$nextTick(() => {
            let all_trs = document
              .getElementById("orders_table")
              .querySelectorAll(".orders_table_row");
            // console.log(all_trs);
            all_trs[all_trs.length - 1].click();
            this.orders_expanded = true;
          });
        });
      }
      return true;
    },
    create_order() {
      // console.log("creating new order for client: " + this.client.inn);
      this.http
        .post("/neworder/", {
          client_id: this.client.inn
        })
        .then(response => {
          console.log(response);
          this.refresh_client_data().then(res => {
            this.snack_message = "Новый заказ создан";
            this.showsnack = true;
            let neworders_table = this.$refs["neworders_table"];
            let last_page = Math.ceil(
              neworders_table.itemsLength /
                neworders_table.computedPagination.rowsPerPage
            );
            this.$refs["neworders_table"].updatePagination({
              page: last_page
            });
            this.$nextTick(() => {
              let all_trs = document
                .getElementById("neworders_table")
                .querySelectorAll(".neworders_table_row");
              // console.log(all_trs);
              all_trs[all_trs.length - 1].click();
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
      return;
    },

    save_order(new_order, event) {
      console.log("saving order...");
      let mybutton = event.currentTarget;

      mybutton.classList.add("v-btn--disabled");
      this.http
        .put("/neworder/" + new_order.order_id, {
          items: new_order.items
        })
        .then(response => {
          console.log(response);
          this.snack_message = "Заказ сохранён успешно";
          this.showsnack = true;
          mybutton.classList.remove("v-btn--disabled");
        })
        .catch(error => {
          console.log(error);
          mybutton.classList.remove("v-btn--disabled");
        });
      return;
    },
    delete_order(myorder, event) {
      let mybutton = event.currentTarget;
      this.$confirm("<center>Вы уверены, что хотите удалить заказ?</center>", {
        title: "Внимание"
      }).then(res => {
        if (res) {
          console.log("deleting order...");
          mybutton.classList.add("v-btn--disabled");
          this.http
            .delete("/neworder/" + myorder.order_id, {})
            .then(response => {
              this.orders_new.splice(myorder.index, 1);
              console.log(response);
              this.refresh_client_data();
              this.snack_message = "Заказ удалён";
              this.showsnack = true;
              mybutton.classList.remove("v-btn--disabled");
            })
            .catch(error => {
              console.log(error);
              mybutton.classList.remove("v-btn--disabled");
            });
        }
      });
      return;
    },
    save_client(event) {
      console.log("saving client...");
      let mybutton = event.currentTarget;

      mybutton.classList.add("v-btn--disabled");
      this.http
        .put("/client/" + this.client.inn, this.client)
        .then(response => {
          console.log(response);
          this.snack_message = "Данные сохранены";
          this.showsnack = true;
          mybutton.classList.remove("v-btn--disabled");
          this.formOptions.disableAll = true;
        })
        .catch(error => {
          console.log(error);
          mybutton.classList.remove("v-btn--disabled");
          this.formOptions.disableAll = true;
        });
      return;
    },
    activate_key(event) {
      let mybutton = event.currentTarget;
      console.log(this.act_product_serial);

      this.$confirm(
        "<center>Вы уверены, что хотите хотите активировать серийный номер?</center>",
        {
          title: "Внимание"
        }
      ).then(res => {
        if (res) {
          console.log("activating product...");
          mybutton.classList.add("v-btn--disabled");
          this.http
            .post("/activate/" + this.act_product_serial, {
              hw_id: this.act_hw_id,
              reg_name: this.act_user_id
            })
            .then(response => {
              console.log(response);
              this.refresh_client_data();
              this.activate_dialog = false;
              this.snack_message = response.data;
              this.showsnack = true;
              mybutton.classList.remove("v-btn--disabled");
            })
            .catch(error => {
              console.log(error);
              mybutton.classList.remove("v-btn--disabled");
            });
        }
      });
      return;
    },
    register_barcode(event) {
      let mybutton = event.currentTarget;
      console.log(this.act_product_barcode);

      this.$confirm(
        "<center>Вы уверены, что хотите зарегистрировать серийный номер?</center>",
        {
          title: "Внимание"
        }
      ).then(res => {
        if (res) {
          console.log("register product...");
          mybutton.classList.add("v-btn--disabled");
          this.http
            .post("/activate/barcode/", {
              product_key: this.act_product_barcode,
              client_inn: this.client.inn
            })
            .then(response => {
              console.log(response);
              this.refresh_client_data();
              this.register_barcode_dialog = false;
              this.snack_message = response.data;
              this.showsnack = true;
              mybutton.classList.remove("v-btn--disabled");
            })
            .catch(error => {
              console.log(error);
              mybutton.classList.remove("v-btn--disabled");
            });
        }
      });
      return;
    },
    onCopyClipboard() {
      this.snack_message = "Данные скопированы в буфер обмена";
      this.showsnack = true;
      return;
    },
    onErrorClipboard() {
      return;
    },
    async refresh_client_data() {
      console.log("refreshing client data....");
      if (!this.current_client) {
        await this.http.get("/users/" + this.token).then(response => {
          console.log(response.data);
          this.fullname = response.data.user_fullname;
          this.username = response.data.user_name;
        });
      }
      if (!this.current_client) {
        await this.http.get("/clients/" + this.token).then(response => {
          console.log(response.data);
          if (response.data[0].client) {
            this.current_client = response.data;
          } else {
            this.new_client = true;
            return;
          }
        });
      }
      if (!this.new_client) {
        console.log(
          "getting data for client: " +
            this.current_client[this.current_client_index].name +
            " inn: " +
            this.current_client[this.current_client_index].client
        );

        await this.http
          .get(
            "/client/" + this.current_client[this.current_client_index].client
          )
          .then(response => {
            // console.log(response.data.orders);
            //this.orders = response.data.orders;
            //response.data.orders = null;
            this.product_keys = response.data.product_keys;
            console.log("Got these product keys:");
            console.log(response.data);
            console.log("done product keys");
            response.data.product_keys = null;

            this.orders_new = response.data.neworders;
            response.data.neworders = null;

            this.client = response.data;
            this.showCompanyForm = false;
            this.$nextTick(() => {
              this.showCompanyForm = true;
            });
            this.http
              .get("/products")
              .then(response => {
                //console.log(response.data);
                this.products = response.data;
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    update_token_data() {
      let self = this;
      this.http = axios.create({
        baseURL: "https://api.admin.edu.e-musica.ru/v2/",
        // baseURL: "http://192.168.0.100:5000/v2/",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token
        }
      });
      this.http.interceptors.response.use(
        function(response) {
          return response;
        },
        function(error) {
          console.log(error.response.data);
          if (error.response.status === 401) {
            console.log("NO AUTHORIZATION!!!");
            self.logout_user();
          }
          return Promise.reject(error);
        }
      );
    },
    make_suggestion_script() {
      let self = this;
      let jquery = document.createElement("script"),
        suggestions = document.createElement("script"),
        suggestionsStyle = document.createElement("link");

      jquery.setAttribute(
        "src",
        "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js"
      );
      jquery.setAttribute("defer", "");
      suggestions.setAttribute(
        "src",
        "https://cdn.jsdelivr.net/npm/suggestions-jquery@19.4.2/dist/js/jquery.suggestions.min.js"
      );
      suggestions.setAttribute("defer", "");
      suggestionsStyle.setAttribute(
        "href",
        "https://cdn.jsdelivr.net/npm/suggestions-jquery@19.4.2/dist/css/suggestions.min.css"
      );

      suggestionsStyle.setAttribute("rel", "stylesheet");

      document.head.appendChild(jquery);
      document.head.appendChild(suggestionsStyle);

      jquery.onload = function() {
        document.head.appendChild(suggestions);
        suggestions.onload = function() {
          jQuery(document).ready(function($) {
            function join(arr) {
              var separator = arguments.length > 1 ? arguments[1] : ", ";
              return arr
                .filter(function(n) {
                  return n;
                })
                .join(separator);
            }

            function showCompanySuggestion(suggestion) {
              // console.log(suggestion);
              var data = suggestion.data;
              if (!data) return;

              if (data.name) {
                $("#company").val(
                  join(
                    [
                      (data.opf && data.opf.short) || "",
                      data.name.short || data.name.full
                    ],
                    " "
                  )
                );
                self.new_inn = data.inn;
                self.new_kpp = data.kpp;
                self.new_company_name = data.name.short_with_opf;
                self.new_fio = data.management.name;
                self.new_position = data.management.post;
              }

              if (data.address) {
                self.new_legal_address = data.address.value;
              }
            }

            $("#ContactFormOrganization").suggestions({
              token: "0e8e39fb3df4f2164bf80a25ed9f4e9c42883a31",
              type: "PARTY",
              count: 6,
              onSelect: showCompanySuggestion
            });
          });
        };
      };
    }
  },
  filters: {
    format_date(value) {
      let date = new Date(value);
      return (
        ("0" + date.getDate()).slice(-2) +
        "." +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "." +
        date.getFullYear()
      );
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    calc_total(x) {
      let total = 0;
      for (let i = 0; i < x.length; i++) {
        total += x[i].product_price * x[i].quantity;
      }
      return total;
    }
  },

  data() {
    return {
      disable_cancel_button: false,
      disable_save_button: true,
      columnDefs: null,
      rowData: null,
      columnDefsUsers: null,
      rowDataUsers: null,
      gridApi: null,
      gridApiUsers: null,
      autoSizeStrategy: {
        type: "fitCellContents"
      },
      russian_locale: {
        // for filter panel
        page: "Страница",
        more: "ещё",
        to: "к",
        of: "из",
        next: "Следующая",
        last: "Последняя",
        first: "Первая",
        previous: "Предыдущая",
        loadingOoo: "Загрузка...",

        // for set filter
        selectAll: "Выделить всё",
        searchOoo: "Поиск...",
        blanks: "Ничего не найдено",

        // for number filter and text filter
        filterOoo: "Фильтровать...",
        applyFilter: "Применить фильтр...",
        equals: "Равно",
        notEqual: "Не равно",

        // for number filter
        lessThan: "Меньше чем",
        greaterThan: "Больше чем",
        lessThanOrEqual: "Меньше или равно",
        greaterThanOrEqual: "Больше или равно",
        inRange: "В промежутке",

        // for text filter
        contains: "Содержит",
        notContains: "Не содержит",
        startsWith: "Начинается с",
        endsWith: "Заканчивается",

        // filter conditions
        andCondition: '"И"',
        orCondition: '"ИЛИ"',

        // the header of the default group column
        group: "Группа",

        // tool panel
        columns: "Столбцы",
        filters: "Фильтры",
        rowGroupColumns: "Столбцы группировки по строкам",
        rowGroupColumnsEmptyMessage:
          "Перетащите сюда для группировки по строкам",
        valueColumns: "Столбцы со значениями",
        pivotMode: "Режим сводной таблицы",
        groups: "Группы",
        values: "Значения",
        pivots: "Заголовки столбцов",
        valueColumnsEmptyMessage: "Перетащите сюда для агрегации",
        pivotColumnsEmptyMessage:
          "Перетащите сюда, чтобы задать заголовки столбам",
        toolPanelButton: "Панель инструментов",

        // other
        noRowsToShow: "Нет данных",

        // enterprise menu
        pinColumn: "Закрепить колонку",
        valueAggregation: "Агрегация по значению",
        autosizeThiscolumn: "Автоматически задавать размер этой колонки",
        autosizeAllColumns: "Автоматически задавать размер всем колонкам",
        groupBy: "Группировать по",
        ungroupBy: "Разгруппировать по",
        resetColumns: "Сбросить столбцы",
        expandAll: "Развернуть всё",
        collapseAll: "Свернуть всё",
        toolPanel: "Панель инструментов",
        export: "Экспорт",
        csvExport: "Экспорт в CSV",
        excelExport: "Экспорт в Excel (.xlsx)",
        excelXmlExport: "Экспорт в XML (.xml)",

        // enterprise menu pinning
        pinLeft: "Закрепить слева <<",
        pinRight: "Закрепить справа >>",
        noPin: "Не закреплять <>",

        // enterprise menu aggregation and status bar
        sum: "Сумма",
        min: "Минимум",
        max: "Максимум",
        none: "Пусто",
        count: "Количество",
        average: "Среднее значение",
        filteredRows: "Отфильтрованные",
        selectedRows: "Выделенные",
        totalRows: "Всего строк",
        totalAndFilteredRows: "Строк",

        // standard menu
        copy: "Копировать",
        cut: "Вырезать",
        copyWithHeaders: "Копировать с заголовком",
        copyWithGroupHeaders: "Копировать с заголовком по группам",

        ctrlC: "Ctrl+C",
        paste: "Чтобы вставить, нажмите",
        ctrlV: "Ctrl+V"
      },
      username: null,
      password: null,
      fullname: null,
      fullnameRules: [v => !!v || "Требуется ввести полное имя пользователя"],
      passwordRules: [v => !!v || "Требуется ввести пароль"],
      emailRules: [
        v => !!v || "Требуется ввести email",
        v =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Неверный адрес email"
      ],
      loginform_valid: false,
      regform_valid: false,
      // Данные для формы первоначальной регистрации компании
      new_inn: null,
      new_kpp: null,
      new_legal_address: null,
      new_company_name: null,
      new_position: null,
      new_fio: null,
      new_inn_status: null,
      new_company_exists: null,
      verify_product_key: null,
      new_product_key: null,
      http: null,
      // Переменные для объекта VJsonschemaForm
      schema: {
        $schema: "http://json-schema.org/draft-07/schema#",
        type: "object",
        required: ["name", "inn"],
        properties: {
          name: {
            title: "Наименование организации",
            type: "string",
            description: "Наименование организации",
            maxLength: 255
          },
          fio: {
            title: "ФИО подписанта лицензионного договора",
            type: "string",
            description: "ФИО подписанта лицензионного договора",
            maxLength: 1000
          },
          position: {
            title: "Должность подписанта",
            type: "string",
            description: "Должность подписанта",
            maxLength: 1000
          },
          osnovanie: {
            title: "На основании какого документа действует подписант",
            type: "string",
            description: "На основании какого документа действует подписант",
            maxLength: 1000
          },

          inn: {
            title: "ИНН компании",
            type: "string",
            description: "ИНН компании",
            maxLength: 16
          },
          kpp: {
            title: "КПП компании",
            type: "string",
            description: "КПП компании",
            maxLength: 16
          },
          legal_address: {
            title: "Юридический адрес",
            type: "string",
            description: "Юридический адрес",
            maxLength: 1000
          },
          postal_address: {
            title: "Фактический адрес",
            type: "string",
            description: "Фактический адрес",
            maxLength: 1000
          },
          bank_name: {
            title: "Название банка",
            type: "string",
            description: "Название банка",
            maxLength: 255
          },
          bank_bik: {
            title: "БИК",
            type: "string",
            description: "БИК",
            maxLength: 1000
          },
          bank_ras_schet: {
            title: "Расчётный счёт в банке",
            type: "string",
            description: "Расчётный счёт в банке",
            maxLength: 1000
          },
          bank_kor_schet: {
            title: "Корреспондентский счёт",
            type: "string",
            description: "Корреспондентский счёт",
            maxLength: 1000
          },
          phone: {
            title: "Номер телефона",
            type: "string",
            description: "Номер телефона",
            maxLength: 255
          },
          email: {
            title: "Адрес электронной почты (email)",
            type: "string",
            description: "Адрес электронной почты (email)",
            maxLength: 50
          }
        }
      },
      formValid: false,
      formOptions: {
        debug: false,
        disableAll: true,
        autoFoldObjects: true
      },
      showCompanyForm: true,
      // Переменные для бокового меню
      drawer: null,
      clipped: false,
      search: "",
      subsearch: "",
      search_new: "",
      subsearch_new: "",
      // Переменные получаемые с сервера по REST
      current_client: null,
      new_client: null,
      e1: 0,
      current_client_index: 0,
      client: [],
      orders: [],
      product_keys: [],
      orders_new: [],
      orders_new_index: null,
      products: [],
      dialog: false,
      activate_dialog: false,
      register_barcode_dialog: false,
      edit_users_dialog: false,
      ebs_stats_dialog: false,
      orders_expanded: false,
      act_product_name: "",
      act_product_serial: "",
      act_hw_id: null,
      act_user_id: null,
      act_product_barcode: null,
      version: process.env.VUE_APP_VERSION,
      showsnack: false,
      snack_message: "",
      users_list: [
        {
          user_email: "qwqwdqdw@adsasd.com",
          user_fullname: "asdasd asdasd asasd"
        },
        {
          user_email: "123123123@adsasd.com",
          user_fullname: "213213 123123 123123"
        },
        {
          user_email: "123123123@adsasd.com",
          user_fullname: "213213 123123 123123"
        },
        {
          user_email: "123123123@adsasd.com",
          user_fullname: "213213 123123 123123"
        },
        {
          user_email: "qwqwdqdw@adsasd.com",
          user_fullname: "asdasd asdasd asasd"
        },
        {
          user_email: "123123123@adsasd.com",
          user_fullname: "213213 123123 123123"
        },
        {
          user_email: "123123123@adsasd.com",
          user_fullname: "213213 123123 123123"
        },
        {
          user_email: "123123123@adsasd.com",
          user_fullname: "213213 123123 123123"
        },
        {
          user_email: "qwqwdqdw@adsasd.com",
          user_fullname: "asdasd asdasd asasd"
        },
        {
          user_email: "123123123@adsasd.com",
          user_fullname: "213213 123123 123123"
        },
        {
          user_email: "123123123@adsasd.com",
          user_fullname: "213213 123123 123123"
        },
        {
          user_email: "123123123@adsasd.com",
          user_fullname: "213213 123123 123123"
        }
      ],
      headers: [
        {
          text: "Номер заказа",
          value: "order_name",
          align: "right"
        },
        { text: "Дата заказа", value: "order_date", align: "right" },
        {
          text: "Дата передачи ключей",
          value: "keymake_date",
          align: "right"
        },
        { text: "Менеджер", value: "manager_name", align: "right" }
      ],
      subHeaders: [
        { text: "Артикул", align: "right", value: "product_text_id" },
        {
          text: "Наименования продукта",
          value: "product_name",
          align: "right"
        },
        {
          text: "Серийный номер",
          value: "product_serial",
          align: "right"
        },
        {
          text: "Номер заказа",
          value: "order_name",
          align: "right"
        }
      ],
      headers_new: [
        {
          text: "Номер заказа",
          value: "order_id",
          align: "right"
        },
        { text: "Дата заказа", value: "order_date", align: "right" },
        { text: "Комментарии", value: "comments", align: "right" },
        {
          text: "Статус заказа",
          value: "order_status",
          align: "right"
        },
        { text: "Менеджер", value: "manager_name", align: "right" }
      ],
      subHeaders_new: [
        { text: "Обложка", align: "center", sortable: false },
        { text: "Артикул", align: "right", value: "product_text_id" },
        {
          text: "Наименования продукта",
          value: "product_name",
          align: "right"
        },
        { text: "Кол-во", value: "quantity", align: "center" },
        {
          text: "Сумма",
          value: "product_price",
          align: "right",
          sortable: false
        },
        { text: "", align: "center", sortable: false }
      ],
      productHeaders: [
        { text: "Обложка", align: "center", sortable: false },
        { text: "Артикул", align: "right", value: "product_text_id" },
        {
          text: "Наименования продукта",
          value: "product_name",
          align: "right"
        }
      ],
      drawer: true,
      menuitems: [
        { title: "Помощь", icon: "fa-question-circle", page: 5 },
        { title: "Мои продукты", icon: "fa-key", page: 1 },
        { title: "Профиль компании", icon: "fa-building", page: 3 },
        { title: "Профиль пользователя", icon: "fa-user", page: 4 },
        { title: "Выход", icon: "fa-sign-out-alt", page: 6 }
      ]
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    currentDate() {
      return new Date().setHours(0, 0, 0, 0);
    }
  },
  watch: {
    token(val) {
      this.update_token_data();
    },
    new_client(val) {
      this.make_suggestion_script();
    }
  },
  mounted() {
    this.update_token_data();
    this.confirm_email();
    this.confirm_password();
    if (this.$store.state.token) {
      this.refresh_client_data();
    }
  }
};
</script>

<style lang="scss">
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-quartz.css";

.mynumber input {
  text-align: right;
}
.fade-enter-active {
  transition: opacity 0.3s ease;
  transition-delay: 0.2s;
  position: absolute;
}
.fade-leave-active {
  transition: opacity 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.mymenu {
  background-color: #f5f5f5;
}

body {
  background-image: url("~@/assets/bg2.svg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left top;
  position: relative;
}

.v-stepper,
.v-stepper__wrapper,
.v-stepper__items {
  overflow: visible !important;
}
.suggestions-subtext {
  color: #575757;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.suggestions-suggestions {
  color: #575757;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.suggestions-promo-desktop {
  display: none;
  opacity: 0;
  pointer-events: none;
}
.myscale:hover {
  transform: scale(1.1);
  transform-origin: center;
  transition: transform 0.35;
  overflow: hidden;
}
.flex_dialog {
  display: flex;
  flex-direction: column;
  height: 80%;
  justify-content: center;
}
.flex_card {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.flex_form {
  height: 100%;
}
</style>
